export default __webpack_public_path__ + "static/media/1244.bf9a34ac.png";